import { TargetGroupIdSchema as m } from "@hprofits/shared";
import { PrivilegeEnum as t } from "@hprofits/shared/auth";
import { z as p } from "zod";
import "../common/acl-view.js";
import { ocPrivate as r } from "../common/auth/procedure-builders.js";
import { createCreationResultSchema as i } from "../common/creation-result.js";
import "../common/owner.js";
import { TargetGroupIdParamSchema as o, CampaignGroupIdParamSchema as u } from "../common/params.js";
import "../common/errors/constants.js";
import { inUseError as s, notFoundError as a, alreadyExistsError as g } from "../common/errors/contract.js";
import "../common/errors/schemas.js";
import "../swagger/security.js";
import { SwaggerTags as e } from "../swagger/tags.js";
import { RenameTargetGroupSchema as n, UpdateTargetGroupSchema as d, TargetGroupSchema as c, CopyTargetGroupSchema as G, CreateTargetGroupSchema as T, TargetGroupListSchema as h } from "./schemas.js";
const x = {
  targetGroup: {
    /**
     * Get all target groups for a campaign
     */
    findAll: r([t.ReadAdvert]).route({
      method: "GET",
      path: "/campaigns/{campaignId}/target-groups",
      summary: "Get all target groups for a campaign",
      tags: [e.TARGET_GROUPS.name]
    }).input(u).output(h).errors({
      ...a("Campaign not found")
    }),
    /**
     * Create a new target group for a campaign.
     *
     * Note on input shape: each input below is `Schema.unwrap().extend({...paramShape})`
     * instead of `paramSchema.and(Schema.unwrap())`. `.and()` produces a `ZodIntersection`
     * which swallows the `unknownKeys: 'strict'` signal of the body — `.strict()` becomes
     * a no-op at the contract boundary. `.extend()` preserves strictness.
     */
    create: r([t.WriteAdvert]).route({
      method: "POST",
      path: "/campaigns/{campaignId}/target-groups",
      summary: "Create a target group for a campaign",
      tags: [e.TARGET_GROUPS.name],
      successStatus: 201
    }).input(
      T.unwrap().omit({ campaignGroupId: !0 }).extend({ campaignId: u.shape.campaignId })
    ).output(i(m)).errors({
      ...a("Campaign or dictionary entity not found"),
      ...g("Target group with this name already exists")
    }),
    /**
     * Copy an existing target group within the same campaign.
     *
     * Modelled as a POST to a `copies` sub-collection rather than a
     * `/{id}/duplicate` verb path: the source is a plain input field, which
     * leaves room for copying across campaigns without another route.
     */
    copy: r([t.WriteAdvert]).route({
      method: "POST",
      path: "/campaigns/{campaignId}/target-groups/copies",
      summary: "Copy a target group within a campaign",
      tags: [e.TARGET_GROUPS.name],
      successStatus: 201
    }).input(G.unwrap().extend({ campaignId: u.shape.campaignId })).output(i(m)).errors({
      ...a("Campaign or source target group not found"),
      ...g("Target group with this name already exists")
    }),
    /**
     * Get a target group by ID
     */
    findOne: r([t.ReadAdvert]).route({
      method: "GET",
      path: "/target-groups/{targetGroupId}",
      summary: "Get a target group by ID",
      tags: [e.TARGET_GROUPS.name]
    }).input(o).output(c).errors({
      ...a("Target group not found")
    }),
    /**
     * Update a target group
     */
    update: r([t.WriteAdvert]).route({
      method: "PUT",
      path: "/target-groups/{targetGroupId}",
      summary: "Update a target group",
      tags: [e.TARGET_GROUPS.name],
      successStatus: 204
    }).input(
      d.unwrap().extend({
        targetGroupId: o.shape.targetGroupId
      })
    ).output(p.void()).errors({
      ...a("Target group or dictionary entity not found")
    }),
    /**
     * Rename a target group
     */
    rename: r([t.WriteAdvert]).route({
      method: "PATCH",
      path: "/target-groups/{targetGroupId}",
      summary: "Rename a target group",
      tags: [e.TARGET_GROUPS.name],
      successStatus: 204
    }).input(
      n.unwrap().extend({
        targetGroupId: o.shape.targetGroupId
      })
    ).output(p.void()).errors({
      ...a("Target group not found"),
      ...g("Target group with this name already exists")
    }),
    /**
     * Delete a target group
     */
    remove: r([t.WriteAdvert]).route({
      method: "DELETE",
      path: "/target-groups/{targetGroupId}",
      summary: "Delete a target group",
      tags: [e.TARGET_GROUPS.name],
      successStatus: 204
    }).input(o).output(p.void()).errors({
      ...a("Target group not found"),
      ...s("Target group is used in ad groups")
    })
  }
};
export {
  x as targetGroupContract
};
//# sourceMappingURL=contract.js.map
